/**
 * angular-strap
 * @version v2.0.0-rc.3 - 2014-02-10
 * @link http://mgcrea.github.io/angular-strap
 * @author Olivier Louvignes (olivier@mg-crea.com)
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
'use strict';
angular.module('mgcrea.ngStrap.strapmodal', ['mgcrea.ngStrap.helpers.dimensions']).provider('$strapmodal', function () {
  var defaults = this.defaults = {
      animation: 'am-fade',
      backdropAnimation: 'am-fade',
      prefixClass: 'strapmodal',
      placement: 'top',
      template: 'strapmodal/strapmodal.tpl.html',
      contentTemplate: false,
      container: false,
      element: null,
      backdrop: true,
      keyboard: true,
      html: false,
      show: true
    };
  this.$get = [
    '$window',
    '$rootScope',
    '$compile',
    '$q',
    '$templateCache',
    '$http',
    '$animate',
    '$timeout',
    'dimensions',
    function ($window, $rootScope, $compile, $q, $templateCache, $http, $animate, $timeout, dimensions) {
      var forEach = angular.forEach;
      var trim = String.prototype.trim || jQuery.trim;
      var requestAnimationFrame = $window.requestAnimationFrame || $window.setTimeout;
      var bodyElement = angular.element($window.document.body);
      var htmlReplaceRegExp = /ng-bind="/gi;
      function ModalFactory(config) {
        var $strapmodal = {};
        var options = angular.extend({}, defaults, config);
        $strapmodal.$promise = fetchTemplate(options.template);
        var scope = $strapmodal.$scope = options.scope && options.scope.$new() || $rootScope.$new();
        if (!options.element && !options.container) {
          options.container = 'body';
        }
        if (!options.scope) {
          forEach([
            'title',
            'content'
          ], function (key) {
            if (options[key])
              scope[key] = options[key];
          });
        }
        scope.$hide = function () {
          scope.$$postDigest(function () {
            $strapmodal.hide();
          });
        };
        scope.$show = function () {
          scope.$$postDigest(function () {
            $strapmodal.show();
          });
        };
        scope.$toggle = function () {
          scope.$$postDigest(function () {
            $strapmodal.toggle();
          });
        };
        if (options.contentTemplate) {
          $strapmodal.$promise = $strapmodal.$promise.then(function (template) {
            var templateEl = angular.element(template);
            return fetchTemplate(options.contentTemplate).then(function (contentTemplate) {
              var contentEl = findElement('[ng-bind="content"]', templateEl[0]).removeAttr('ng-bind').html(contentTemplate);
              if (!config.template)
                contentEl.next().remove();
              return templateEl[0].outerHTML;
            });
          });
        }
        var strapmodalLinker, strapmodalElement;
        var backdropElement = angular.element('<div class="' + options.prefixClass + '-backdrop"/>');
        $strapmodal.$promise.then(function (template) {
          if (angular.isObject(template))
            template = template.data;
          if (options.html)
            template = template.replace(htmlReplaceRegExp, 'ng-bind-html="');
          template = trim.apply(template);
          strapmodalLinker = $compile(template);
          $strapmodal.init();
        });
        $strapmodal.init = function () {
          if (options.show) {
            scope.$$postDigest(function () {
              $strapmodal.show();
            });
          }
        };
        $strapmodal.destroy = function () {
          if (strapmodalElement) {
            strapmodalElement.remove();
            strapmodalElement = null;
          }
          if (backdropElement) {
            backdropElement.remove();
            backdropElement = null;
          }
          scope.$destroy();
        };
        $strapmodal.show = function () {
          var parent = options.container ? findElement(options.container) : null;
          var after = options.container ? null : options.element;
          strapmodalElement = $strapmodal.$element = strapmodalLinker(scope, function (clonedElement, scope) {
          });
          strapmodalElement.css({ display: 'block' }).addClass(options.placement);
          if (options.animation) {
            if (options.backdrop) {
              backdropElement.addClass(options.backdropAnimation);
            }
            strapmodalElement.addClass(options.animation);
          }
          if (options.backdrop) {
            $animate.enter(backdropElement, bodyElement, null, function () {
            });
          }
          $animate.enter(strapmodalElement, parent, after, function () {
          });
          scope.$isShown = true;
          scope.$$phase || scope.$digest();
          var el = strapmodalElement[0];
          requestAnimationFrame(function () {
            el.focus();
          });
          bodyElement.addClass(options.prefixClass + '-open');
          if (options.backdrop) {
            strapmodalElement.on('click', hideOnBackdropClick);
            backdropElement.on('click', hideOnBackdropClick);
          }
          if (options.keyboard) {
            strapmodalElement.on('keyup', $strapmodal.$onKeyUp);
          }

          scope.$emit('modal.show', null);
        };
        $strapmodal.hide = function () {
          $animate.leave(strapmodalElement, function () {
            bodyElement.removeClass(options.prefixClass + '-open');
          });
          if (options.backdrop) {
            $animate.leave(backdropElement, function () {
            });
          }
          scope.$isShown = false;
          scope.$$phase || scope.$digest();
          if (options.backdrop) {
            strapmodalElement.off('click', hideOnBackdropClick);
            backdropElement.off('click', hideOnBackdropClick);
          }
          if (options.keyboard) {
            strapmodalElement.off('keyup', $strapmodal.$onKeyUp);
          }

          scope.$emit('modal.hide', null);
        };
        $strapmodal.toggle = function () {
          scope.$isShown ? $strapmodal.hide() : $strapmodal.show();
        };
        $strapmodal.focus = function () {
          strapmodalElement[0].focus();
        };
        $strapmodal.$onKeyUp = function (evt) {
          evt.which === 27 && $strapmodal.hide();
        };
        function hideOnBackdropClick(evt) {
          if (evt.target !== evt.currentTarget)
            return;
          options.backdrop === 'static' ? $strapmodal.focus() : $strapmodal.hide();
        }
        return $strapmodal;
      }
      function findElement(query, element) {
        return angular.element((element || document).querySelectorAll(query));
      }
      function fetchTemplate(template) {
        return $q.when($templateCache.get(template) || $http.get(template)).then(function (res) {
          if (angular.isObject(res)) {
            $templateCache.put(template, res.data);
            return res.data;
          }
          return res;
        });
      }
      return ModalFactory;
    }
  ];
}).directive('bsModal', [
  '$window',
  '$location',
  '$sce',
  '$strapmodal',
  function ($window, $location, $sce, $strapmodal) {
    return {
      restrict: 'EAC',
      scope: true,
      link: function postLink(scope, element, attr, transclusion) {
        var options = {
            scope: scope,
            element: element,
            show: false
          };
        angular.forEach([
          'template',
          'contentTemplate',
          'placement',
          'backdrop',
          'keyboard',
          'html',
          'container',
          'animation'
        ], function (key) {
          if (angular.isDefined(attr[key]))
            options[key] = attr[key];
        });
        angular.forEach([
          'title',
          'content'
        ], function (key) {
          attr[key] && attr.$observe(key, function (newValue, oldValue) {
            scope[key] = $sce.getTrustedHtml(newValue);
          });
        });
        attr.bsModal && scope.$watch(attr.bsModal, function (newValue, oldValue) {
          if (angular.isObject(newValue)) {
            angular.extend(scope, newValue);
          } else {
            scope.content = newValue;
          }
        }, true);
        var strapmodal = $strapmodal(options);
        element.on(attr.trigger || 'click', strapmodal.toggle);
        scope.$on('$destroy', function () {
          strapmodal.destroy();
          options = null;
          strapmodal = null;
        });
      }
    };
  }
]);